<template>
    <div class="col-sm-12 d-flex flex-wrap py-3 pt-4">

        <div class="text-center" v-if="getIsGettingReservationById">
            <loader></loader>
        </div>

        <route-form v-else :transfer="reservation.transport.transfers[0]" :routes="routes" :reservation="reservation" title="Pick up location" :type="1" :readOnly="isReservationReadOnly"></route-form>

        <!-- <transport-editor v-if="routes.length > 0" v-model="reservation.transport.transfers[0]" :possibleRoutes="possibleRoutes" :transportType="1" :eventDate="reservation.event.start"></transport-editor> -->

        <!-- <transport-editor v-if="routes.length > 0" v-model="reservation.transport.transfers[1]" :possibleRoutes="possibleRoutes" :transportType="2" :eventDate="reservation.event.start"></transport-editor> -->

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'

import {mapGetters} from 'vuex'
import TransportEditor from '@/tools/TransportEditor'
import Loader from '@/tools/loaders/loader1'

import RouteForm from '@/components/reservations/NewReservation/Resume/AddTransport/RouteForm'
export default {
    data: function() {
        return {
            routes: [],
            roundTrip: false
        }
    },
    props:{
        reservation:{
            type: Object
        }
    },
    created: function() {
        this.routes = this.getAllRoutes
    },
    computed: {
        ...mapGetters([
            'account',
            'getIsGettingReservationById',
            'getAllRoutes'
        ]),
        possibleRoutes: function(type) {
            return this.routes.filter(route => {
                return this.reservation.event.eventRoutes.filter(eventRoute => {
                    return eventRoute.id == route.id
                }).length > 0
            })
        },
    },
    mixins:[
        reservationsMixin
    ],
    methods:{
        createNumberOfTransfers: function() {
            // just makes the transfers array the correct length
            let numberOfTransfers = 2;

            if(this.reservation.transport.transfers.length < numberOfTransfers){
                for (var i = 0; i < numberOfTransfers; i++) {
                    this.reservation.transport.transfers.push({
                        order: 0,
                        date: null,
                        transportDirection: 1,
                        isCustom: false,
                        route: null,
                        stop: null,
                        exitStop: null,
                        schedule: null,
                    })
                }
            }
        },
        hasTransportChanged: function(e) {
            if(e.value == false){
                this.reservation.transport.transfers = [];
                this.createNumberOfTransfers();
            }
        }
    },
    components: {
        RouteForm,
        TransportEditor,
        Loader
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabTransport.vue?397f62bc